import React from 'react';
import { Stack } from "@mui/material";
import attachFileIcon from "../../../../../styles/svg/attachment.svg";
import filterIcon from "../../../../../styles/svg/epic-icon.svg";
import { CustomButton } from '../../../../../components/Button/Button';
import newSearchIcon from "../../../../../styles/svg/newSearchIcon.svg"

const MobileActions = ({ setAttachmentDialog, attachmentDialog, setFilterDrawer, openSearchField, handleOpenSearchField }) => {
  return (
    <Stack direction="row" className="d-flex align-items-center">
      <img 
        src={newSearchIcon} 
        className="mobile-board-search-icon"   
        alt="search" 
        onClick={handleOpenSearchField}
      />

      <CustomButton
        variant="outlined"
        color="primary"
        className="white-button attach-btn board-header-attach-btn"
        onClick={() => setAttachmentDialog({ ...attachmentDialog, right: true })}
      >
        <img
          src={attachFileIcon}
          className="header-filter-icon"
          alt="not found"
        />
      </CustomButton>
      <img
        src={filterIcon}
        alt="filter"
        className="board-header-filter-icon"
        onClick={() => setFilterDrawer(true)}
      />
      
    </Stack>
  );
};

export default MobileActions; 